// firebase init goes here
const config = {
    apiKey: "AIzaSyDxks1eyFuRz4G1wDlkTFoY1izI5_JhHfw",
    authDomain: "go-checkin-2020.firebaseapp.com",
    databaseURL: "https://go-checkin-2020.firebaseio.com",
    projectId: "go-checkin-2020",
    storageBucket: "go-checkin-2020.appspot.com",
    messagingSenderId: "355192029650"
}

export default config;